/**
 * "Jobs on this well" — the well's jobs, newest register order, on the well's
 * own page (GET /well-testing/jobs?wellId=, fieldiq-api#1245). A row opens the
 * job; dispatch roles get New job, which opens the form on this well.
 */
import React from 'react';
import { Plus } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useWtJobs } from '../../hooks/useWellTesting';
import { canDispatchWt, wtJobStatusSkin } from '../../lib/well-testing';
import { useOpenRecord } from '../downhole/recordPage';
import { JobCard, jobColumns } from './JobBits';
import { WT_SECONDARY, WtEmpty, WtPanel, WtRegister } from './WtBits';

export function WellJobsSection({ wellId }: { wellId: string }) {
  const { user } = useAuth();
  const openRecord = useOpenRecord();
  const query = useWtJobs({ wellId });
  const jobs = query.data?.data ?? [];
  return (
    <WtPanel
      eyebrow="Jobs"
      title="Jobs on this well"
      testId="wt-well-jobs"
      actions={
        canDispatchWt(user?.role) ? (
          <button type="button" className={WT_SECONDARY} onClick={() => openRecord(`/well-testing/jobs/new?wellId=${wellId}`)}>
            <Plus className="size-4" aria-hidden="true" />
            New job
          </button>
        ) : undefined
      }
    >
      <WtRegister
        query={query}
        rows={jobs}
        columns={jobColumns({ withWell: false })}
        rail={(j) => wtJobStatusSkin(j.status).rail}
        onOpen={(j) => openRecord(`/well-testing/jobs/${j.id}`)}
        subject="this well's jobs"
        testId="wt-well-job"
        minWidth="min-w-[760px]"
        empty={<WtEmpty>No job has been opened on this well yet.</WtEmpty>}
        card={(j) => <JobCard job={j} />}
      />
    </WtPanel>
  );
}
